'use client';

import clsx from 'clsx';
import React, { useCallback,useState } from 'react';

import { Button } from '@/components/button/button';
import Modal from '@/components/modal/modal';
import { Heading } from '@/components/typography/heading';

import styles from './modalRunRerun.module.scss';

type Props = {
  onClose: () => void;
  onConfirm: ( includeReason: boolean ) => void;
  sourceName?: string;
  sourceVersion?: number;
  isLoading?: boolean;
};

export default function ModalRunRerun( props: Props ) {
  /* DATA */
  const {
    onClose,
    onConfirm,
    sourceName,
    sourceVersion,
    isLoading = false
  } = props;

  const [ includeReason, setIncludeReason ] = useState<boolean>( false );

  /* HANDLERS */
  const handleConfirm = useCallback( () => {
    onConfirm( includeReason );
  }, [ includeReason ] );

  return (
    <Modal>
      <div className={ styles.content }>
        <Heading as="h2" size="md">Rerun Evaluation</Heading>
        <div className={ clsx( 'layout__col', 'pad' ) }>
          <p>
            Creating a new run with{' '}
            {sourceName ? (
              <strong>
                {sourceName} (v{sourceVersion ?? 'Latest'})
              </strong>
            ) : (
              'this source'
            )}
            ?
          </p>
        </div>
        <div className={ clsx( 'layout__col', 'pad' ) }>
          <label
            className='auth_flow_label'
            style={ { display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' } }
          >
            <input
              type='checkbox'
              checked={ includeReason }
              onChange={ ( e ) => setIncludeReason( e.target.checked ) }
              style={ { cursor: 'pointer' } }
              disabled={ isLoading }
            />
            <b>Include evaluation reasoning in results.</b><br/><i>Shows the model’s reasoning for the score it assigns to this run.</i>
          </label>
        </div>
        <div className={ clsx( 'layout__row', 'pad', 'flex_right' ) }>
          <Button variant='secondary' size='sm' onClick={ onClose } disabled={ isLoading }>
            Cancel
          </Button>
          <Button
            variant='primary'
            size='sm'
            onClick={ handleConfirm }
            loading={ isLoading }
            disabled={ isLoading }
          >
            Rerun
          </Button>
        </div>
      </div>
    </Modal>
  );
}
